let url;

switch (process.env.ROMEU_ENV) {
  default:
  case 'development':
    url = 'http://romeu.test:4040/api';
    break;
  case 'staging':
    url = 'https://stg-api.romeuferries.com/api';
    break;
  case 'production':
    url = 'https://api.romeuferries.com/api';
    break;
}

export default url;



// WEBPACK FOOTER //
// ./src/shared/lib/urlApi.js